import { dom } from '@omegagrid/core';
import { msg } from '@omegagrid/localize';
import { ToolbarItem } from '@omegagrid/toolbar';
import rp, { Application, ParsedComponentId, GridEditor, EditorContainer } from '@reporting/rp-app-host';
import { ItemIndicatorGridEditorAdapter, ItemCompIndicatorGridEditorAdapter } from './adapters/items';
import { IndicatorGroup } from "./types";

const itemIndicatorsGridEditorId = (group: IndicatorGroup) => `definition-itemIndicatorsGridEditor-${group}`;

/** The indicators of one group (turnovers / balances / calculated): the toolbar buttons switch the group, the checked one is the group shown */
export const createItemIndicatorsContainer = (app: Application, componentId: ParsedComponentId) => {
	const group = componentId.ids[1] as IndicatorGroup || 'T';
	const groupButton = (id: IndicatorGroup, icon: string, text: string): ToolbarItem => ({type: 'togglebutton', id, group: 'group', icon, text, value: id == group});
	return dom.createElement<EditorContainer>('rp-editor-container', {
		items: [
			groupButton('T', 'gauge-max', msg('Turnovers')),
			groupButton('B', 'scale-balanced', msg('Balances')),
			groupButton('C', 'calculator-simple', msg('Calculated')),
		],
		cacheComponents: true, // a switch back shows the grid of the group as it was left, unsaved edits included
		innerComponentId: itemIndicatorsGridEditorId(group),
		createComponent: id => rp.host.createComponent(id),
		updateComponentId: values => itemIndicatorsGridEditorId(values['group'] as IndicatorGroup || 'T'),
	});
}

export const createItemIndicatorsGridEditor = (app: Application, componentId: ParsedComponentId) => {
	const group = componentId.ids[1] as IndicatorGroup;
	if (!group) return null;
	const component = dom.createElement<GridEditor>('rp-editor-grid');
	component.adapter = group == 'C' ? new ItemCompIndicatorGridEditorAdapter() : new ItemIndicatorGridEditorAdapter(group);
	return component;
}
